// extracted by mini-css-extract-plugin
module.exports = {"marginSidebar":"App__marginSidebar--19_mC","main":"App__main--2Fp6u"};